<template>
  <div id="general-form-app" class="rental__registerform">
    <div class="loading-overlay" v-if="loading">
      <div class="loading-ring"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
    </div>
    <transition name="component-fade" mode="out-in">
    <Component
      :is="view"
      :privacyPage="privacyPage"
      :errorMessage="errorMessage"
      @updateStep="view = $event"
      @handleRequest="handleRequest()"
    :registerform="registerform"></Component>
    </transition>
  </div>
</template>

<script>
import Form from '@/views/Form'
import Error from '@/views/Error'
import axios from 'axios'

export default {
  name: 'App',
  data () {
    return {
      loading: false,
      view: 'Form',
      // users who don´t have chosen a license should be in waiting contact of license 2
      // and get a special color to identify them, this will be handled by the state 99 (onboarding backend)
      state: 99,
      license: 2,
      privacyPage: window.tx_rental.privacyPage,
      successPage: window.tx_rental.successPage,
      apiBase: window.tx_rental.typo3ApiBase,
      errorMessage: [],
      registerform: {
        vehicleCount: 1,
        contact: {
          salutation: '',
          company: '',
          firstname: '',
          lastname: '',
          zip: '',
          city: '',
          email: '',
          phone: '',
          availability: '',
          privacy: false
        }
      }
    }
  },
  components: {
    Form,
    Error
  },
  methods: {
    handleRequest: function () {
      let apiBase = this.apiBase
      let url = new URL(apiBase + 'step-one')

      url.searchParams.set('state', this.state)
      url.searchParams.set('license', this.license)
      url.searchParams.set('salutation', this.registerform.contact.salutation)
      url.searchParams.set('contact-firstname', this.registerform.contact.firstname)
      url.searchParams.set('contact-lastname', this.registerform.contact.lastname)
      url.searchParams.set('company', this.registerform.contact.company)
      url.searchParams.set('zip', this.registerform.contact.zip)
      url.searchParams.set('city', this.registerform.contact.city)
      url.searchParams.set('email', this.registerform.contact.email)
      url.searchParams.set('phone', this.registerform.contact.phone)
      url.searchParams.set('availability', this.registerform.contact.availability)
      url.searchParams.set('privacy', this.registerform.contact.privacy)
      let self = this
      this.loading = true
      axios.post(url).then(response => {
        window.location.href = this.successPage
        self.loading = false
        console.log(response)
      }).catch(e => {
        self.step = 'Error'
        self.loading = false
        self.errorMessage = e.response.data.errors
      })
    }
  }
}
</script>
